import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module13World.css';
import '../../Animations.css';
import loading from './../../loading-gif-png-5.gif';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from '../Module13/Practice';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule8 from '../../FollowTheBeat/FollowTheBeatModule8.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';

const Module13World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module13 } = useSelector((state) => state.module13, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png');
  const animal = generateImageUrl('images/Module3Images/Lizard+closing+still+image.gif');
  const progressbar0 = generateImageUrl('images/Module3Images/LizTongue_Empty_100819.svg');
  const progressbar1 = generateImageUrl('images/Module3Images/LizTongue_1out3_100819.svg');
  const progressbar2 = generateImageUrl('images/Module3Images/LizTongue_2out3_100819.svg');
  const progressbar3 = generateImageUrl('images/Module3Images/LizTongue_2out3_100819.svg');
  const progressbarCompleted = generateImageUrl('images/Module3Images/LizTongue_Complete_100819.svg');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const fly = generateImageUrl('images/Module3Images/Fly.png');
  const CactusBarell = generateImageUrl('images/Module3Images/Reward_SmallCactus1.png');
  const CactusPrickly = generateImageUrl('images/Module3Images/Reward_SmallCactus2.png');
  const StegoBlue = generateImageUrl('images/Module8Images/DailyReward_Stego_Blue.png');
  const StegoGreen = generateImageUrl('images/Module8Images/DailyReward_Stego_Green.png');
  const Tent = generateImageUrl('images/Module3Images/Reward_Tent1.png');
  const TentOld = generateImageUrl('images/Module3Images/Reward_Tent2.png');
  const LongNeckGreen = generateImageUrl('images/Module8Images/DailyReward_DinoLongNeck_Green.png');
  const LongNeckRed = generateImageUrl('images/Module8Images/DailyReward_DinoLongNeck_Red.png');
  const Backpack = generateImageUrl('images/Module3Images/Reward_Backpack.png');
  const Canteen = generateImageUrl('images/Module3Images/Reward_Cantina.png');
  const Plant1 = generateImageUrl('images/Module8Images/DailyReward_Plant1.png');
  const Plant2 = generateImageUrl('images/Module8Images/DailyReward_Plant2.png');
  const Hat = generateImageUrl('images/Module3Images/Reward_Cowboyhat.png');
  const Bandanna = generateImageUrl('images/Module3Images/Reward_Bandana.png');
  const RaptorLight = generateImageUrl('images/Module8Images/DailyReward_Raptor_LightBlue.png');
  const RaptorDark = generateImageUrl('images/Module8Images/DailyReward_Raptor_Darker.png');
  const Volcano = generateImageUrl('images/newDesign/Unit2Module8/BigRewardVolcanoNoSmoke.png');
  const TRex = generateImageUrl('images/Module8Images/BigReward_TRex@2x.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'c318108517ea3db5bcb847d2024e/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [specialMessage, setSpecialMessage] = useState('');
  const [watchConversation, setWatchConversation] = useState('');
  const [amazingJob, setAmazingJob] = useState('');

  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [checkStep, setCheckStep] = useState('');
  const [rewardAnimationState, setRewardAnimationState] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [showFly, setShowFly] = useState(false);
  const [lizardTongue, setLizardTongue] = useState('');
  const [bugSound, setBugSound] = useState(false);
  const [lizardTongueAudio, setLizardTongueAudio] = useState('');
  const [playLizardClose, setPlayLizardClose] = useState(false);
  const [animalClose, setAnimalClose] = useState('');
  const [animalCloseAudio, setAnimalCloseAudio] = useState('');
  const [displayFTB, setDisplayFTB] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [awesomeJob, setAwesomeJob] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'))

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const playButtonAudio = useCallback(() => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  }, []);

  function getGifs() {
    setAwesomeJob(getVideo('appfiles/ask/ask_awesome_job.mp3', login));
    setLizardTongue(getVideo('appfiles/expressions/lizard_fly.gif', login));
    setSpecialMessage(getVideo('appfiles/ask/ask_special_message.gif', login));
    setWatchConversation(getVideo('appfiles/ask/ask_conversation.gif', login));
    setAmazingJob(getVideo('appfiles/ask/Ask Awesome Job.gif', login));
    setPracticeIntro(getVideo('appfiles/ask/ask_practice_intro.gif', login));
    setLizardTongueAudio(getVideo('appfiles/expressions/expressions_fly_catch.mp3', login));
    setLearnIntro(getVideo('appfiles/ask/ask_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/ask/ask_ftb_intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/ask/ask_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/ask/ask_closing.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/change_feelings/change_feelings_day_finished.mp3', login));
    setFTBInstruction(getVideo('appfiles/change_feelings/change_feelings_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/ask/ask_lizard_ftb_instructions.gif', login));
    setFTBMusic(getVideo('appfiles/ask/ask_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/ask/countingLizard.gif', login));

    if (!module13.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));
      setFTBTutorial2(getVideo('appfiles/change_feelings/ftb_walkthrough_shrug.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/ask/ftb_walkthrough_audio.mp3', login));
    }

  }

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module13.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.psuh(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module13.rewards) {
          if (module13.rewards[key].unlocked === true) {
            const rewards = {
              type: key,
              x_multiplier: module13.rewards[key].x,
              y_multiplier: module13.rewards[key].y,
            };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE13_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module13.game_details, module13.rewards]
  );

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "ChangeFeelings",
				day_completed: module13.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = useCallback(async () => {
    const myInit = {
      body: {
        id: module13.moduleID,
        day_completed: module13.day_completed,
        step_completed: module13.stepCompleted,
        game_details: JSON.stringify(module13.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayLizardClose(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch(() => {
        if (
          module13.stepCompleted === 'notstarted' ||
          module13.stepCompleted === 'learn' ||
          module13.stepCompleted === 'practice' ||
          module13.stepCompleted === 'celebrate' ||
          module13.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'ChangeFeelings',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  });

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module13.stepCompleted]); // delete

    useEffect(() => {
      if((module13.reviewIcon === true || login.grade === "Teacher Mode") && module13.sectionCompleted === 4 ) {
          updateProgress();
          module13.sectionCompleted = 0;
      }
    }, [module13.sectionCompleted])

  useEffect(() => {
    if (module13.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module13.coins);
      updateDB();
    }
  }, [module13.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  useEffect(() => {
    if (module13.currentday <= module13.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE13_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE13_SET_KEY', payload: 4 });
      if (module13.currentday === 4 || module13.currentday === 8) {
        dispatch({ type: 'MODULE13_SET_KEY', payload: 5 });
      }
    } else {
      if (module13.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE13_TOGGLE_REVIEW_ICON', payload: false });
      if (module13.currentday === 4 && module13.day_completed === 3) {
        if (module13.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 0 });

        } else if (module13.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 1 });

        } else if (module13.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 2 });

        } else if (module13.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 3 });

        } else if (module13.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 4 });
        } else if (module13.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE13_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module13.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 0 });

        } else if (module13.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 1 });
  
        } else if (module13.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 2 });
     
        } else if (module13.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 3 });

        } else if (module13.stepCompleted === 'celebrate') {
          if (module13.currentday === 8 && module13.day_completed === 7) {
            dispatch({ type: 'MODULE13_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE13_SET_KEY', payload: 4 });
          }
        } else if (module13.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE13_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module13.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);

  const selectReward = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                setTouchButton(true);
                dispatch({
                  type: `MODULE13_SET_REWARD${module13.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE13_SET_REWARD${module13.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                setTouchButton(true);
                dispatch({
                  type: `MODULE13_SET_REWARD${module13.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE13_SET_REWARD${module13.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE13_SET_DAY_UNLOCK${module13.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE13_SET_dayCompleted',
                    payload: module13.currentday === 8 ? 9 : module13.currentday,
                  });
                  dispatch({
                    type: 'MODULE13_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={Volcano}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE13_SET_PRIZE1', payload: true });
                dispatch({ type: 'MODULE13_SET_PRIZE2', payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={TRex}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE13_SET_PRIZE2', payload: true });
                dispatch({ type: 'MODULE13_SET_PRIZE1', payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE13_SET_COIN',
                    payload: module13.coins - 100,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module13.currentday) {
      case 1:
        setRewardOption1(CactusBarell);
        setRewardOption2(CactusPrickly);
        break;
      case 2:
        setRewardOption1(StegoBlue);
        setRewardOption2(StegoGreen);
        break;
      case 3:
        setRewardOption1(Tent);
        setRewardOption2(TentOld);
        break;
      case 4:
        setRewardOption1(LongNeckRed);
        setRewardOption2(LongNeckGreen);
        break;
      case 5:
        setRewardOption1(Canteen);
        setRewardOption2(Backpack);
        break;
      case 6:
        setRewardOption1(Plant1);
        setRewardOption2(Plant2);
        break;
      case 7:
        setRewardOption1(Bandanna);
        setRewardOption2(Hat);
        break;
      case 8:
        setRewardOption1(RaptorDark);
        setRewardOption2(RaptorLight);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [
    keyIcon,
    Backpack,
    Bandanna,
    CactusBarell,
    CactusPrickly,
    Canteen,
    Hat,
    LongNeckGreen,
    LongNeckRed,
    Plant1,
    Plant2,
    RaptorDark,
    RaptorLight,
    StegoBlue,
    StegoGreen,
    Tent,
    TentOld,
    module13.currentday,
  ]);

  const displayReview = () => {
    if (module13.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/changefeelings/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module13.currentday === 4) {
              dispatch({ type: 'MODULE13_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module13.day_completed === 9) {
              navigate('/changefeelings/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song =  getVideo('appfiles/change_feelings/change_feelings_demo.m4a', login);
    let video = getVideo('appfiles/change_feelings/learn_video.mp4', login);
    switch (module13.currentday) {
      case 1:
        setLearn(
          <Learn
            video='295800c2c2f245aaa6d861ec3909/480.m3u8'
            songVideo={video}
            closingVideo={generateImageUrl('media/Module13/U3M3_Learn_close_day1.mp4')}
            destiny='/changefeelings'
            song={song}
            back='/changefeelings'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE13_SET_stepCompleted'
            module={module13}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='cb5aa9b3999e70860b3fd7313552/480.m3u8'
            songVideo={video}
            closingVideo={generateImageUrl('media/Module13/U3M3_Learn_close_day2.mp4')}
            destiny='/changefeelings'
            song={song}
            back='/changefeelings'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE13_SET_stepCompleted'
            module={module13}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='Module13/learn_day3.mp4'
            songVideo={video}
            closingVideo={generateImageUrl('media/Module13/U3M3_Learn_close_day3.mp4')}
            destiny='/changefeelings'
            song={song}
            back='/changefeelings'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE13_SET_stepCompleted'
            module={module13}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/change_feelings/change_feelings_learn_intro.mp3', login));
        // // setDisplayVoice(true);
        // setAnimalState(learnIntro);
        // setShowAnimal(true);
        GetUserVideo(`userfiles/${module13.StudentID}/change_feelings_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module13.currentday - 4]}/ask_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/changefeelings'
                    song={data}
                    back='/changefeelings'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE13_SET_stepCompleted'
                    module={module13}
                    instrumental={getVideo('appfiles/change_feelings/change_feelings_sing_along.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/changefeelings'
                    song={song}
                    back='/changefeelings'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE13_SET_stepCompleted'
                    module={module13}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    // switch (module13.currentday) {
    //   case 1:
    //     break;
    //   case 2:
    //     break;
    //   case 3:
    //     break;

    //   default:
    //     setAnimalVoice(getVideo('appfiles/change_feelings/change_feelings_ftb_intro.mp3', login));
    //     // setDisplayVoice(true);
    //     setAnimalState(ftbIntro);
    //     setShowAnimal(true);
    //     break;
    // }

    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'e59222ec1d8bdc49206cee6f3dc5/480.m3u8   ';
    const celebrateVideo2 = '0d2f23c98256f79d63554a97f2f3/480.m3u8';
    const celebrateVideo3 = '6da6f426ed1fadbdfb0c4c5870a8/480.m3u8';

    switch (module13.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module13}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE13'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module13}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE13'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module13}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE13'}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/change_feelings/change_feelings_celebrate_intro.mp3', login));
        // // setDisplayVoice(true);
        // setAnimalState(celebrateIntro);
        // setShowAnimal(true);
        let voice1 = getVideo('appfiles/ask/ask_celebrate_record_important.mp3', login);
        let voice2 = getVideo('appfiles/ask/ask_celebrate_say_yes.mp3', login);
        let voice3 = getVideo('appfiles/ask/ask_awesome_job.mp3', login);
        let animalGIF = getVideo('appfiles/change_feelings/lizard joyful jingle.gif', login);
        let animalVoice = getVideo('appfiles/change_feelings/change_feelings_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module13.currentday - 4]}/ask_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module13}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={
                'Record yourself in an excited voice and say, "I am a very important person!"'
              }
              name={`change_feelings_celebration_surprise_${
                module13.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE13'}
              lizard={true}
              bigAnimal={true}
            />
          );
        })
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '16a8d2066efd3e988426a95edfde/480.m3u8';
    let noteVideo = getVideo('appfiles/change_feelings/change_feelings_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/change_feelings/change_feelings_demo.m4a', login);
    let instrumental = getVideo('appfiles/change_feelings/change_feelings_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module13}
        moduleNum='MODULE13'
        name='change_feelings'
        instrumental={instrumental}
        instrumentalURL={'appfiles/change_feelings/change_feelings_sing_along.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module13.StudentID}/change_feelings_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module13.StudentID}/change_feelings_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/ask_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module13.StudentID}/change_feelings_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/ask_affirmation.mp4`,
      },
    ];
    
    // Use a loop to simplify the repetitive code
    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
    
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/change_feelings/change_feelings_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });

    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const rewardAnimation = () => {
    setRewardAnimationState('fade-out-fly');
    sleep(1000).then(() => {
      flyAnimation();
    });
  };

  const flyAnimation = () => {
    setShowFly(true);
    setAnimalState(lizardTongue);
    setAnimalVoice(lizardTongueAudio);
    setShowAnimal(true);
    setKeyIcon(false);
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(AfterCelebrateVideo9);
    setShowAnimal(false);
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE13_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE13_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  return (
    <>
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE13_SET_COIN',
              payload: module13.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playLizardClose && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayLizardClose(false);
            module13.currentday === 8
              ? closeDay9Video()
              : navigate('/changefeelings/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}

      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (showFly) {
              setShowFly(false);
              setDisplayReward(true);
              setRewardsFound(true);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {displayPractice && (
        <Practice
          setDisplayPractice={setDisplayPractice}
          background={background}
          stepComplete={'MODULE13_SET_stepCompleted'}
          module={module13}
          watchConversation={watchConversation}
          specialMessage={specialMessage}
          amazingJob={amazingJob}
          animal={animal}
        />
      )}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule8
          unit3={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={awesomeJob}
          awesomeJobGIF={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE13_SET_stepCompleted'} 
          module={module13}
          score={'ftb_change_feelings'}
        />
      )}
      {displaySingingTime && singTime}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='askWorldBody'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                navigate('/changefeelings/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                rewardAnimation();
                sleep(1000).then(() => {
                  sleep(5000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='lizard' src={animal} alt='lizard Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              className={
                animalState === lizardTongue ? 'lizardTongue' : 'animatedLizard'
              }
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
              
            />
            {module13.coins < 10 && (
              <h5 className='scoretext1'>{module13.coins}</h5>
            )}
            {module13.coins >= 10 && module13.coins < 100 && (
              <h5 className='scoretext10'>{module13.coins}</h5>
            )}
            {module13.coins >= 100 && (
              <h5 className='scoretext100'>{module13.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module13.currentday === 4 || module13.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module13.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module13.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module13.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module13.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module13.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module13.currentday === 4 &&
                  module13.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module13.currentday !== 4 &&
                  module13.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module13.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={practiceBtn}
                    alt='practice button'
                    onClick={() => {
                      touchSound.play();
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}
                {module13.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={ftbBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}
                {module13.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={celebrateBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}
                {module13.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module13.reviewIcon === false && (
                <img
                  className='chooseReward'
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex:10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            (<div className='actionBtnDiv'>
              {module13.reviewIcon &&
                (<img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                  />)}
                  {showReward && (
                    <img
                      src={rewardBtn}
                      className='actionBtn4'
                      alt='review button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          rewardAnimation();
                        });
                      }}
                  />)}
                {module13.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon && keyIcon && !disPlayPrize && (
            <img
              style={{ width: '80px', height: '75px' }}
              className='rewardsIcon'
              id={rewardAnimationState}
              src={fly}
              alt='reward key'
              onClick={() => {
                rewardAnimation();
              }}
            />
          )}
          {showFly && audioReady && (
            <div id='flyY'>
              <img
                style={{ width: '80px', height: '75px' }}
                className='flyPosition'
                id={'flyX'}
                alt=''
                src={fly}
              />
            </div>
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module13.rewards.CactusBarell.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.CactusBarell.x * clientWidth,
                  y: module13.rewards.CactusBarell.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveSmallReward1'
                  style={{ backgroundImage: `url(${CactusBarell})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.CactusPrickly.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.CactusPrickly.x * clientWidth,
                  y: module13.rewards.CactusPrickly.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveSmallReward2'
                  style={{ backgroundImage: `url(${CactusPrickly})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.StegoBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.StegoBlue.x * clientWidth,
                  y: module13.rewards.StegoBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveStegoReward1'
                  style={{ backgroundImage: `url(${StegoBlue})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.StegoGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.StegoGreen.x * clientWidth,
                  y: module13.rewards.StegoGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveStegoReward2'
                  style={{ backgroundImage: `url(${StegoGreen})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Tent.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Tent.x * clientWidth,
                  y: module13.rewards.Tent.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveTent1'
                  style={{ backgroundImage: `url(${Tent})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.TentOld.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.TentOld.x * clientWidth,
                  y: module13.rewards.TentOld.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveBigReward2'
                  style={{ backgroundImage: `url(${TentOld})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.LongNeckRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.LongNeckRed.x * clientWidth,
                  y: module13.rewards.LongNeckRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveLongBigReward1'
                  style={{ backgroundImage: `url(${LongNeckRed})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.LongNeckGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.LongNeckGreen.x * clientWidth,
                  y: module13.rewards.LongNeckGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveLongBigReward2'
                  style={{ backgroundImage: `url(${LongNeckGreen})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Canteen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Canteen.x * clientWidth,
                  y: module13.rewards.Canteen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveCanteenReward1'
                  style={{ backgroundImage: `url(${Canteen})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Backpack.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Backpack.x * clientWidth,
                  y: module13.rewards.Backpack.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveBackpack2'
                  style={{ backgroundImage: `url(${Backpack})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Plant1.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Plant1.x * clientWidth,
                  y: module13.rewards.Plant1.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='movePlantReward1'
                  style={{ backgroundImage: `url(${Plant1})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Plant2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Plant2.x * clientWidth,
                  y: module13.rewards.Plant2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='movePlantReward2'
                  style={{ backgroundImage: `url(${Plant2})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Bandanna.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Bandanna.x * clientWidth,
                  y: module13.rewards.Bandanna.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${Bandanna})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Hat.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.Hat.x * clientWidth,
                  y: module13.rewards.Hat.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveCharaterReward2'
                  style={{ backgroundImage: `url(${Hat})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.RaptorDark.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.RaptorDark.x * clientWidth,
                  y: module13.rewards.RaptorDark.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveRaptorReward1'
                  style={{ backgroundImage: `url(${RaptorDark})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.RaptorLight.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module13.rewards.RaptorLight.x * clientWidth,
                  y: module13.rewards.RaptorLight.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveRaptorReward2'
                  style={{ backgroundImage: `url(${RaptorLight})` }}
                ></div>
              </Draggable>
            )}

            {module13.rewards.Volcano.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module13.rewards.Volcano.x * clientWidth, y: module13.rewards.Volcano.y * clientHeight}}
                onStop={(e,data)=>{onStop(1, data)}}
                ><div className='movePrize13' style={{backgroundImage: `url(${Volcano})`}}></div></Draggable>}

            {module13.rewards.TRex.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module13.rewards.TRex.x * clientWidth, y: module13.rewards.TRex.y * clientHeight}}
                onStop={(e,data)=>{onStop(2, data)}}
                ><div className='movePrize23' style={{backgroundImage: `url(${TRex})`}}></div></Draggable>}
          </div>
        </div>
      )}
    </>
  );
};
export default Module13World;
